<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Tags</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (tags$ | async; as tags) {
            <div>
                <p>Total Tags: {{ tags.length }}</p>
            </div>
            <div>
                <h3>Popular Tags</h3>
                <table mat-table [dataSource]="dataSource">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let row">
                            {{ row.displayName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef>Count</th>
                        <td mat-cell *matCellDef="let row">
                            {{ row.count }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        }
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button [routerLink]="['/a/tag']" color="primary">Edit</button>
    </mat-card-actions>
</mat-card>
